export const SET_ADDRESSES = 'setAddresses'
export const SET_SHOP_ADDRESSES = 'setShopAddresses'
export const SET_ADDRESS_AUTHORIZATIONS = 'setAddressAuthorizations'
export const SET_ADDRESS_TEMPLATES = 'setAddressTemplates'
export const SET_ADDRESS_PENDING_REQUEST = 'setAddressPendingRequest'
